<template>
  <div>
    <div>
      <div class="d-flex">
        <div class="title-location header-title" :style="{ width: `calc(${descriptionColumn}px + 350px)` }">
          BÁN {{ type === 'mass' ? 'BUÔN' : 'LẺ' }}
        </div>
        <div class="content-location error--text" :style="{ width: '100px' }">
          {{ getTotalQuantityOfCity('totalInventoryQuantity') | formatNumber }}
        </div>
        <div class="content-location error--text" :style="{ width: '100px' }">
          {{ getTotalQuantityOfCity('totalSupplierStoreQuantity') | formatNumber }}
        </div>
        <div class="content-location error--text" :style="{ width: '100px' }">
          {{ getTotalQuantityOfCity('totalSystemStoreQuantity') | formatNumber }}
        </div>
        <div
          class="content-location error--text"
          :style="{ width: '100px' }"
          v-if="$auth.policies['import-report-on-times:view-system-store-price']"
        >
          {{ getTotalQuantityOfCity('totalSystemStorePrice') | formatNumber }}
        </div>
        <div class="content-location error--text" :style="{ width: '100px' }">
          {{ getTotalQuantityOfCity('totalSupplierSample') | formatNumber }}
        </div>
        <div class="content-location error--text" :style="{ width: '100px' }">
          {{ getTotalQuantityOfCity('totalBadSkinQuantity') | formatNumber }}
        </div>
        <div class="content-location error--text" :style="{ width: '100px' }">
          {{ getTotalQuantityOfCity('totalDebtStoreQuantity') | formatNumber }}
        </div>
        <div class="content-location error--text" :style="{ width: '80px' }"></div>
      </div>
      <div class="divider-custom my-4"></div>
      <div v-if="Object.keys(listAreas).length">
        <div v-for="(area, aidx) in Object.keys(listAreas)" :key="area">
          <v-divider class="my-2" :style="{ 'margin-right': '80px' }" v-if="aidx !== 0" />
          <div class="d-flex">
            <div class="title-location" :style="{ width: `calc(${descriptionColumn}px + 350px)` }">
              <div class="pl-4">{{ convertNameLocation(area) }}</div>
            </div>
            <div class="content-location" :style="{ width: '100px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalInventoryQuantity') | formatNumber }}
            </div>
            <div class="content-location" :style="{ width: '100px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalSupplierStoreQuantity') | formatNumber }}
            </div>
            <div class="content-location" :style="{ width: '100px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalSystemStoreQuantity') | formatNumber }}
            </div>
            <div
              class="content-location"
              :style="{ width: '100px' }"
              v-if="$auth.policies['import-report-on-times:view-system-store-price']"
            >
              {{ getTotalQuantityOfArea(listAreas[area], 'totalSystemStorePrice') | formatNumber }}
            </div>
            <div class="content-location" :style="{ width: '100px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalSupplierSample') | formatNumber }}
            </div>
            <div class="content-location" :style="{ width: '100px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalBadSkinQuantity') | formatNumber }}
            </div>
            <div class="content-location" :style="{ width: '100px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalDebtStoreQuantity') | formatNumber }}
            </div>
            <div class="content-location" :style="{ width: '80px' }"></div>
          </div>
          <div v-for="(inventory, invenIdx) in listAreas[area]" :key="invenIdx">
            <div
              @mouseover="() => showEyes(inventory.id)"
              @mouseleave="selectId = null"
              @click="() => $emit('openListImeiDialog', inventory.id)"
              class="d-flex mt-2 inventory-detail"
            >
              <div class="title-location" :style="{ width: `calc(${descriptionColumn}px + 350px)` }">
                <div class="pl-8">{{ inventory.name }}</div>
              </div>
              <div class="content-location" :style="{ width: '100px' }">
                {{ (inventory.totalInventoryQuantity || 0) | formatNumber }}
              </div>
              <div class="content-location" :style="{ width: '100px' }">
                {{ (inventory.totalSupplierStoreQuantity || 0) | formatNumber }}
              </div>
              <div class="content-location" :style="{ width: '100px' }">
                {{ (inventory.totalSystemStoreQuantity || 0) | formatNumber }}
              </div>
              <div
                class="content-location"
                :style="{ width: '100px' }"
                v-if="$auth.policies['import-report-on-times:view-system-store-price']"
              >
                {{ (inventory.totalSystemStorePrice || 0) | formatNumber }}
              </div>
              <div class="content-location" :style="{ width: '100px' }">
                {{ (inventory.totalSupplierSample || 0) | formatNumber }}
              </div>
              <div class="content-location" :style="{ width: '100px' }">
                {{ (inventory.totalBadSkinQuantity || 0) | formatNumber }}
              </div>
              <div class="content-location" :style="{ width: '100px' }">
                {{ (inventory.totalDebtStoreQuantity || 0) | formatNumber }}
              </div>
              <div class="content-location text-center" :style="{ width: '80px' }">
                <v-icon v-show="selectId === inventory.id" size="20" color="primary">mdi-eye</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { groupBy, sum, get } from 'lodash'
import api from '@/plugins/api'
export default {
  name: 'ListInventoryExpand',
  props: {
    displayType: String,
    type: String,
    model: Object,
    descriptionColumn: {
      type: Number,
      default: null
    }
  },
  methods: {
    ...mapActions({
      fetchInventories: 'inventories/fetchItems',
      fetchInventoryReport: 'reportInventoryOnTimes/fetchItems'
    }),
    showEyes(inventory) {
      this.selectId = inventory
    },
    getTotalQuantityOfArea(val, type) {
      const listQuantity = val.map(i => Number(i[type]) || 0)
      return sum(listQuantity)
    },
    getTotalQuantityOfCity(type) {
      let listAreasArr = []
      const listAreas = JSON.parse(JSON.stringify(this.listAreas))
      Object.keys(listAreas).forEach(key => {
        listAreasArr = [...listAreasArr, ...listAreas[key]]
      })
      const listQuantity = listAreasArr.map(i => Number(i[type]) || 0)
      return sum(listQuantity)
    },
    convertNameLocation(val) {
      return this.$utils.convertCodeLocationToName(val)
    }
  },
  watch: {
    model: {
      async handler(val) {
        if (val) {
          const params = {
            productModel: val.productModel
          }
          if (val.date) {
            params.date = val.date
          }
          console.log('🚀 ~ handler ~ params:', params)
          let res = await api['ReportOnTimes'].getAreaReportOnTime(params)
          this.listAreas = groupBy(res, 'location')
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      selectId: null,
      listAreas: {},
      listAreasArr: [],
      get
    }
  }
}
</script>
<style lang="scss" scoped>
.inventory-detail {
  height: 24px;
  &:hover {
    background: #e0e0e0;
    cursor: pointer;
  }
}
.custom-input {
  text-align: right;
  width: 100%;
  border: 1px solid;
  padding-right: 4px;
}

.title-location {
  padding: 0 8px;
  text-align: start;
  font-size: 14px;
  color: #3e3e3c;
}

.content-location {
  padding: 0 8px;
  text-align: end;
  font-size: 14px;
  color: #3e3e3c;
}

.header-title {
  font-size: 16px;
  font-weight: 500;
}

.divider-custom {
  width: calc(100% - 80px);
  background: black;
  height: 1px;
}
</style>
